import * as React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useRouteMatch } from "react-router-dom";

const Resource = (props: any) => {
  const match = useRouteMatch();
  const { image, titleKey, descriptionKey, routeUrl } = props.resource;
  const { t } = useTranslation();

  const IMG = (imgName: string) => {
    return require(`./../../../../../../../../assets/images/svg/${imgName}.svg`)
      ?.default;
  };

  return (
    <NavLink
      to={match.url + routeUrl}
      className="p-2 m-2 bg-white border rounded-md shadow-sm cursor-pointer w-60 hover:border-blue-700 hover:shadow-xl"
    >
      <div className="flex items-center justify-center bg-white">
        <img
          className="object-contain w-44 h-44"
          src={IMG(image)}
          alt={t(titleKey)}
        ></img>
      </div>
      <div className="m-2">
        <div className="my-2 font-semibold text-md">{t(titleKey)}</div>
        <p className="my-2 text-sm leading-snug truncate-4-lines">
          {t(descriptionKey)}
        </p>
      </div>
    </NavLink>
  );
};

export default Resource;
